import { render, staticRenderFns } from "./NurseOnboard.vue?vue&type=template&id=afabc942&"
import script from "./NurseOnboard.vue?vue&type=script&lang=js&"
export * from "./NurseOnboard.vue?vue&type=script&lang=js&"
import style0 from "./NurseOnboard.vue?vue&type=style&index=0&id=afabc942&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports